import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { HourlyL1Icon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { HourlyRate } from '@fiverr-private/seller_pages_toolbox';
import { useRollouts } from '../../../hooks/useRollouts';
import { AGENCY_ROLLOUTS } from '../../../../server/middleware/addRollouts/constants';
import { useAgencySellerData } from '../../../hooks/useAgencySellerData';
import { AgencySeller } from '../../../types';

interface HourlyRatesProps extends React.ComponentProps<typeof Stack> {}

export const HourlyRatesInfo: React.FC<HourlyRatesProps> = ({ ...props }) => {
    const { experience } = getContext();
    const { hourlyRates } = useAgencySellerData((seller: AgencySeller) => ({
        hourlyRates: seller.hourlyRate,
    }));
    const rollouts = useRollouts() ?? {};
    const inZebrasHourlyRatesRollout = rollouts[AGENCY_ROLLOUTS.ZEBRAS_HOURLY_RATE];

    if (!hourlyRates || !inZebrasHourlyRatesRollout) {
        return null;
    }

    if (experience.isBusiness) {
        return (
            <Stack {...props}>
                <HourlyRate hourlyRateInUsdCents={hourlyRates.priceInCents} fontSize="b_xxl" />
            </Stack>
        );
    }

    return (
        <Stack gap="2" {...props}>
            <HourlyL1Icon color="grey_1200" size="sm" />
            <Text fontWeight="semibold">
                <I18n k="agency_page_perseus.hourly_rates" />
            </Text>
        </Stack>
    );
};
